import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import { Box, Tooltip } from '@mui/material';

interface ErrorSelectIndicatorProps {
    message: string;
}

/**
 * Styled error indicator for the FlexySelect component
 * Shows only an exclamation mark icon in the middle of the input field
 */
const ErrorSelectIndicator: React.FunctionComponent<ErrorSelectIndicatorProps> = function ({
    message,
}) {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="100%"
            position="absolute"
            top={0}
            left={0}
        >
            <Tooltip
                title={message}
                arrow
                placement="top"
            >
                <ErrorIcon color="error" />
            </Tooltip>
        </Box>
    );
};

export default ErrorSelectIndicator;
